import {generateThemes} from '@nfq/colors';

import type {GetThemeType} from '@nfq/colors';

export const BaseColors = {
    /** Background dark color. ![#F7F7F8](https://dummyimage.com/12/F7F7F8/F7F7F8.png) `#F7F7F8`. */
    backgroundDark: '#F7F7F8',
    /** Background light color. ![#FFFFFF](https://dummyimage.com/12/FFFFFF/FFFFFF.png) `#FFFFFF`. */
    backgroundLight: '#FFFFFF',
    /** Background neutral color. ![#E0E0E0](https://dummyimage.com/12/E0E0E0/E0E0E0.png) `#E0E0E0`. */
    backgroundNeutral: '#E0E0E0',
    /** Dark border color. ![#E0E0E0](https://dummyimage.com/12/303030/303030.png) `#303030`. */
    darkBorder: '#303030',
    /** Invalid color. ![#D32F2F](https://dummyimage.com/12/D32F2F/D32F2F.png) `#D32F2F`. */
    errorColor: '#D32F2F',
    /** Background neutral color. ![#E5E5E5](https://dummyimage.com/12/E5E5E5/E5E5E5.png) `#E5E5E5`. */
    neutral: '#E5E5E5',
    /** Primary color. ![#AB007C](https://dummyimage.com/12/AB007C/AB007C.png) `#AB007C`. */
    primary: '#AB007C',
    /** Primary dark color. ![#84106D](https://dummyimage.com/12/84106D/84106D.png) `#84106D`. */
    primaryDark: '#84106D',
    /** Secondary color. ![#007687](https://dummyimage.com/12/007687/007687.png) `#007687`. */
    secondary: '#007687',
    /** Secondary dark color. ![#1C2E29](https://dummyimage.com/12/1C2E29/1C2E29.png) `#1C2E29`. */
    secondaryDark: '#1C2E29',
    /** Tertiary color. ![#B6CB4C](https://dummyimage.com/12/AFC93A/B6CB4C.png) `#B6CB4C`. */
    tertiary: '#B6CB4C',
    /** Text light color. ![#FFFFFF](https://dummyimage.com/12/FFFFFF/FFFFFF.png) `#FFFFFF`. */
    textLight: '#FFFFFF',
    /** Text neutral color. ![#9E9E9E](https://dummyimage.com/12/9E9E9E/9E9E9E.png) `#9E9E9E`. */
    textNeutral: '#9E9E9E',
    /** Text primary color. ![#282828](https://dummyimage.com/12/282828/282828.png) `#282828`. */
    textPrimary: '#282828',
    /** Text secondary color. ![#666666](https://dummyimage.com/12/666666/666666.png) `#666666`. */
    textSecondary: '#666666'
} as const;

export const DerivedColors = {} as const;

export const BoxShadows = {
    buttonShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.25)',
    menuShadow: '-3px 0px 12px -2px rgba(0, 0, 0, 0.19)',
    /** The default dropshadow for Popovers. */
    popOverShadow: '0px 0px 10px 5px rgba(25, 38, 48, 0.05)'
} as const;

// BaseColors, DerivedColors, BoxShadows, 'light', 'dark'

export type BaseColorsType = GetThemeType<typeof BaseColors>;
export const {
    globalCss,
    shadows,
    themeColors,
    themes
} = generateThemes({
    baseColors: BaseColors,
    derivedColors: DerivedColors,
    shadows: BoxShadows
});